export default "__VITE_ASSET__BkIN_ApN__"